import { type StateTree } from "pinia";
import type { LearningAssessmentStoreState } from "@/store/learning/assessment/state";
import { LearningTaskModel } from "~~/package/mapper/learning/model/LearningTaskModel";
import LearningDirectoryType
    from "~/components/Learning/LearningMiddle/LearningMultiFileCode/LearningDirectory/config/LearningDirectoryType";
import { isEmptyString } from "~/utils/StringUtil";

export interface LearningAssessmentStoreGetters extends StateTree {
    isAssessment: boolean;
    isContest: boolean;
    isLevelAssessment: boolean;
    isProSkillAssure: boolean;
    firstProSkillAssureTask: LearningTaskModel;
    getUserLearningDirectoryType: LearningDirectoryType;
}

export const assessmentGetters = {
    isAssessment(state: LearningAssessmentStoreState): boolean {
        return state.assessmentList.length > 0;
    },
    isContest(state: LearningAssessmentStoreState): boolean {
        return state.contestList.length > 0;
    },
    isLevelAssessment(state: LearningAssessmentStoreState): boolean {
        return state.levelAssessmentIdList.length > 0 || !isEmptyString(state.trackInfo.levelId.toString());
    },
    isProSkillAssure(state: LearningAssessmentStoreState): boolean {
        return state.proSkillAssure.assessment.setList.length > 0;
    },
    firstProSkillAssureTask(state: LearningAssessmentStoreState): LearningTaskModel {
        const taskList = state.proSkillAssure.assessment.setList
            .map(set => set.taskList)
            .flat();
        const proceedingTaskList = taskList.filter(task => !task.completeFlag);
        if (proceedingTaskList.length === 0) {
            if (taskList.length > 0) return taskList[taskList.length - 1];
            else return new LearningTaskModel();
        } else {
            return proceedingTaskList[0];
        }
    },
    getUserLearningDirectoryType(state: LearningAssessmentStoreState & LearningAssessmentStoreGetters): LearningDirectoryType {
        if (state.isLevelAssessment) return LearningDirectoryType.UserLevelAssessment;
        else if (state.isProSkillAssure) return LearningDirectoryType.UserProSkillAssure;
        else if (state.isContest) return LearningDirectoryType.UserContest;
        else return LearningDirectoryType.UserLearning;
    }
};
